export default __webpack_public_path__ + "static/media/SCR.21866b9d.webp";